import { useQuery } from 'react-query'
import { capitalize } from 'lodash'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

// NOTE: en caso de que hubiese que cambiar el orden de los países que tienen
// más prioridad, añadirlos a este array en el orden en que se quiera que
// estén ordenados.
const ISO_ALPHA_2_COUNTRY_CODES = ['ES', 'PT']

const transformCountriesResponse = countriesData => {
  // NOTE: por petición de cliente, los países deben estar ordenados de la
  // siguiente manera: primero España, luego Portugal y después el resto de
  // países ordenados alfabéticamente.
  const countriesWithHighPriority = countriesData.filter(country =>
    ISO_ALPHA_2_COUNTRY_CODES.includes(country.country_code),
  )

  const restCountriesSortedAlphabetically = countriesData
    .filter(
      country => !ISO_ALPHA_2_COUNTRY_CODES.includes(country.country_code),
    )
    .sort((a, b) => {
      if (a.country_name < b.country_name) {
        return -1
      }

      if (a.country_name > b.country_name) {
        return 1
      }

      return 0
    })

  const countries = [
    ...countriesWithHighPriority,
    ...restCountriesSortedAlphabetically,
  ].map(country => ({
    label: capitalize(country.country_name),
    code: country.country_code,
  }))

  return countries
}

export const useDestinationCountries = config => {
  const authedFetch = useAuthedFetch()

  const query = useQuery(
    'destinationCountries',
    () =>
      withFetchCancel(signal =>
        authedFetch('GET', `${BACKEND_ENDPOINT}/available_destin_countries`, {
          parseJSON: true,
          signal,
        }),
      ),
    {
      select: ({ data }) => transformCountriesResponse(data),
      ...config,
    },
  )

  return query
}
